"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitRegExpStringToArray = exports.splitRegexpGroupVariationsIntoArray = void 0;
const REGEX_CONTENT_IN_ROUND_BRACKETS = new RegExp(/^\^?\((.*?)\)\$?$/);
const REGEX_GROUP_BY_SLASH = new RegExp(/(.*?)([^\\]\||$)/, 'g');
const REGEX_GROUP_BY_SEP = new RegExp(/(.*?)\|?$/);
const REGEX_ESCAPED_SPECIAL_SYMBOLS = new RegExp(/\\([\\^$.*+?()[\]{}|])/, 'g');
/**
 * Разбивает строки вида `(a|b|c)` на массив `['a', 'b', 'c']`
 */
const splitRegexpGroupVariationsIntoArray = (regexpString) => {
    const array = [];
    const matches = regexpString.replace(REGEX_CONTENT_IN_ROUND_BRACKETS, '$1').match(REGEX_GROUP_BY_SLASH);
    if (Array.isArray(matches) && matches.length) {
        for (const string of matches) {
            if (string) {
                array.push(string.replace(REGEX_GROUP_BY_SEP, '$1').replace(REGEX_ESCAPED_SPECIAL_SYMBOLS, '$1'));
            }
        }
    }
    return array;
};
exports.splitRegexpGroupVariationsIntoArray = splitRegexpGroupVariationsIntoArray;
/**
 * @deprecated Используйте splitRegexpGroupVariationsIntoArray
 */
exports.splitRegExpStringToArray = exports.splitRegexpGroupVariationsIntoArray;
//# sourceMappingURL=split-regexp-group-variations-into-array.util.js.map